export default __webpack_public_path__ + "static/media/1 (17).3b696c11.jpg";